import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

type RequestType = {
  isLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  error: string | null;
};

const initialState: RequestType = {
  isLoading: false,
  data: null,
  error: "",
};

const isGatewayInvalidInputError = (error: any) =>
  error?.status === 403 ||
  error?.response?.status === 403 ||
  error?.request?.status === 403 ||
  error?.code === "ERR_NETWORK" ||
  error?.message === "Network Error";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const processReturnApprovalOrReject = createAsyncThunk<any, any>(
  "CTDBUpdateApprovalSlice/processReturnApprovalOrReject",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("bmo/product/OrderSku", requestDetails);
      const successStatusCodes = [200, 201, 202];
      if (
        !successStatusCodes.includes(response.status) ||
        response.data.Status !== "success"
      ) {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to update Product.",
          });
        }
      }
      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      if (
        requestDetails?.Action === "rejectreturn" &&
        isGatewayInvalidInputError(error)
      ) {
        return thunkApi.rejectWithValue({
          message:
            "Invalid input detected. Please review the input text and try again!",
        });
      }
      return thunkApi.rejectWithValue({
        message: "Failed to update Product",
      });
    }
  }
);

const ProcessReturnApprovalOrRejectSlice = createSlice({
  name: "CTDBProcessReturnApprovalOrRejectSlice",
  initialState,
  reducers: {
    resetProcessReturnApprovalOrRejectState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(processReturnApprovalOrReject.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        processReturnApprovalOrReject.fulfilled,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data || [];
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        processReturnApprovalOrReject.rejected,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetProcessReturnApprovalOrRejectState } = ProcessReturnApprovalOrRejectSlice.actions;

export default ProcessReturnApprovalOrRejectSlice.reducer;
